import JiyuMailboxPage from './JiyuMailboxPage';
export default JiyuMailboxPage;
export { JiyuMailboxPage };
